import React, { useState } from "react";
import { useDispatch } from "react-redux";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import StarIcon from '@mui/icons-material/Star';

import CustomButton from "../Utils/Custom_Btn";
import SpecialReservationDialog from "../SpecialReservationDialog";
import { CreateSpecialReservation } from "../../Apis/Reservations/Reservations";
import { fetchReservations } from "../../Redux/Reservations_Slice";
import { useToast } from "../../Hooks/useToast";

const MainHeader=({title,onNavigate, secondaryAction, paginationModel, searchFilters })=>{
  const dispatch = useDispatch();
  const { toastSuccess, toastError } = useToast();
  const [specialReservationDialogOpen, setSpecialReservationDialogOpen] = useState(false);
  const [specialReservationLoading, setSpecialReservationLoading] = useState(false);

  const handleOpenSpecialReservation = () => {
    setSpecialReservationDialogOpen(true);
  };

  const handleCloseSpecialReservation = () => {
    setSpecialReservationDialogOpen(false);
  };

  const handleCreateSpecialReservation = async (submissionData) => {
    setSpecialReservationLoading(true);
    
    try {
      console.log("🌟 بدء إنشاء الحجز المميز في الصفحة الرئيسية");
      
      // تواريخ الحجز
      const startDateTime = new Date(
        submissionData.date.getFullYear(),
        submissionData.date.getMonth(),
        submissionData.date.getDate(),
        submissionData.startTime.getHours(),
        submissionData.startTime.getMinutes()
      );
      const endDateTime = new Date(
        submissionData.date.getFullYear(),
        submissionData.date.getMonth(),
        submissionData.date.getDate(),
        submissionData.endTime.getHours(),
        submissionData.endTime.getMinutes()
      );
      
      // تحويل التاريخ بنفس طريقة الحجوزات العادية
      const isoStringWithoutTimezone = new Date(
        startDateTime.getTime() - (startDateTime.getTimezoneOffset() * 60000)
      ).toISOString();
      
      const durationMinutes = Math.max(30, Math.round((endDateTime.getTime() - startDateTime.getTime()) / 60000));

      const reservationData = {
        customerName: submissionData.title,
        customerEmail: 'special@reservation.com',
        customerPhone: '000000000',
        customerStreet: 'Sonderreservierung',
        customerPLZ: '00000',
        customerCity: 'Special',
        packageName: 'Sonderreservierung',
        numberOfPersons: 1,
        dateOfReservation: isoStringWithoutTimezone,
        note: submissionData.description || 'Sonderreservierung',
        isAGift: false,
        selectedGender: '',
        extraObjectsList: [],
        payWay: 'special',
        isSpecial: true,
        isPaid: true,
        duration: durationMinutes
      };

      const response = await CreateSpecialReservation(reservationData);
      console.log("📡 استجابة API للحجز المميز:", response);
      
      if (response.status === 201) {
        console.log("✅ تم إنشاء الحجز المميز بنجاح في الصفحة الرئيسية");
        toastSuccess("Sonderreservierung erfolgreich erstellt!");
        
        handleCloseSpecialReservation();
        
        // إعادة تحميل البيانات
        if (dispatch && paginationModel && searchFilters !== undefined) {
          dispatch(
            fetchReservations({
              page: paginationModel.page + 1,
              limit: paginationModel.pageSize,
              filters: searchFilters
            })
          );
        }
      } else {
        console.log("❌ فشل في إنشاء الحجز المميز - Status:", response.status);
        console.log("❌ تفاصيل الخطأ:", response.data);
        const errorMsg = response?.data?.message || response?.error || `Fehler beim Erstellen: Status ${response.status}`;
        toastError(errorMsg);
      }
      
      setSpecialReservationLoading(false);
      
    } catch (error) {
      console.log("❌ خطأ في إنشاء الحجز المميز:", error);
      toastError("Fehler beim Erstellen der Sonderreservierung. Bitte erneut versuchen.");
      setSpecialReservationLoading(false);
    }
  };

  return(
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 3,
        flexWrap: "wrap",
        gap: 2
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          flexWrap: "wrap"
        }}
      >
        <CustomButton 
          onNavigate={onNavigate} 
          title={title} 
        />
        
        {/* زر الحجز المميز - بنفس تصميم زر Neue Buchung */}
         <Button
          onClick={secondaryAction?.onClick || handleOpenSpecialReservation}
          sx={{
            mb: { xs: "16px", md: "0px" },
            flexShrink: 1,
            backgroundColor: '#FFD700',
            borderRadius: '8px',
            color: 'black',
            fontSize: '14px',
            height: '46px',
            px: '10px',
            pl: 0,
            '&:hover': {
              backgroundColor: '#FFC107'
            }
          }}
          startIcon={
            <Box
              sx={{
                backgroundColor: '#FFC107',
                height: "100%",
                py: 1.3,
                px: 1,
                borderTopLeftRadius: '8px',
                borderBottomLeftRadius: '8px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <StarIcon sx={{ color: 'white' }} />
            </Box>
          }
        >
          <Typography sx={{
            fontSize: { md: "16px", xs: "12px" },
            textTransform: "none"
          }}>
            Sonderreservierung
          </Typography>
        </Button> 
        
      </Box>

      {/* نموذج الحجز المميز */}
      <SpecialReservationDialog
        open={specialReservationDialogOpen}
        onClose={handleCloseSpecialReservation}
        onSubmit={handleCreateSpecialReservation}
        loading={specialReservationLoading}
      />

    </Box>
  )
}
export default MainHeader